import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Observable } from 'rxjs'
import { ServiceOrderService, ServiceType, serviceTypes } from '../service-order.service'

@Component({
  selector: 'app-service-order-shell',
  templateUrl: './service-order-shell.component.html',
  styleUrls: ['./service-order-shell.component.scss'],
  providers: [ServiceOrderService]
})
export class ServiceOrderShellComponent implements OnInit {
  errors$: Observable<any> = this.serviceOrderState.errors$
  constructor(private serviceOrderState: ServiceOrderService, private route:ActivatedRoute) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const param = params.get('service-name') as ServiceType
      if(serviceTypes.includes(param)){
        this.serviceOrderState.setOrderType(param)
      }
      else {
        this.serviceOrderState.setOrderType(ServiceType.SERVICE_ORDER)
      }
    })

  }
}
